import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import GameView from './pages/GameView'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import { AuthProvider } from './context/AuthContext'
import './styles/App.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login"                          element={<LoginPage />} />
          <Route path="/reset-password"                 element={<ResetPasswordPage />} />
          <Route path="/dashboard"                      element={<DashboardPage />} />
          <Route path="/game/:slug"                     element={<GameView />} />
          <Route path="/game/:slug/player/:playerIndex" element={<GameView />} />
          <Route path="/*"                              element={<App />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
)
